import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FilterPipe} from './filter.pipe';
import {DevelopStatusPipe} from './developStatus';
import {DevelopStatusColorPipe} from './developStatusColor';
import {ContactFilterPipe} from './contact-filter';
import {InstitutionLevelPipe} from './institution-level.pipe';
import { ModalShowPipe } from './modalShow';
import { NoSanitizePipe } from './nosanitizerpipe';


@NgModule({
  declarations: [
    FilterPipe,
    DevelopStatusPipe,
    ContactFilterPipe,
    DevelopStatusColorPipe,
    InstitutionLevelPipe,
    ModalShowPipe,
    NoSanitizePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FilterPipe,
    DevelopStatusPipe,
    ContactFilterPipe,
    DevelopStatusColorPipe,
    InstitutionLevelPipe,
    ModalShowPipe,
    NoSanitizePipe
  ]
})
export class PipesModule {
}
